import React from 'react';

function ModuleLayout({ children }) {
  return <div className="module-grid">{children}</div>;
}

export default ModuleLayout;
